<template>
  <div>
    <v-app>
      <Header v-if="$route.name !== 'Login'"/>
      <Drawer v-if="$route.name !== 'Login'" />
      <v-main>
        <v-container fluid>
          <router-view />
        </v-container>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Drawer from "./components/Drawer.vue";

export default {
  name: "App",
  components: {
    Header,
    Drawer,
  },
  data() {
    return {};
  },
};
</script>
